/*
 * Default options that will be provided to every query
 * Please modify these to suit your projects needs
 */
export const defaultOptions = {
  query: {
    clientimeout: 7000
  }
};

/*
 * Type definitions for the three optional objects included
 * in every auto generated query - options, data, queryParams
 */

/*
 * A space for enums not defined by the OpenAPI schema that
 * you may want to include here for one reason or another
 */
export let updateCauses;

/*
 * Types based on enums defined as parts of the OpenAPI schema
 * NOTE: The current generator implementation ignores duplicate names.
 * If you have multiple enums with the same name, you may need to manually
 * add the duplicates to this file.
 */
(function (updateCauses) {
  updateCauses["UPDATED_BY_SUBSCRIBER"] = "UPDATED_BY_SUBSCRIBER";
  updateCauses["UPDATED_VIA_LINKED_SUBSCRIBER"] = "UPDATED_VIA_LINKED_SUBSCRIBER";
  updateCauses["UPDATED_VIA_HUBSPOT_CUSTOMER"] = "UPDATED_VIA_HUBSPOT_CUSTOMER";
  updateCauses["MIGRATION"] = "MIGRATION";
})(updateCauses || (updateCauses = {}));
export let type;
(function (type) {
  type["TERMS"] = "TERMS";
  type["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
  type["HISTOGRAM"] = "HISTOGRAM";
  type["MISSING"] = "MISSING";
  type["BUCKETS"] = "BUCKETS";
  type["TOP_HITS"] = "TOP_HITS";
})(type || (type = {}));
export let intervalUnit;
(function (intervalUnit) {
  intervalUnit["SECOND"] = "SECOND";
  intervalUnit["MINUTE"] = "MINUTE";
  intervalUnit["HOUR"] = "HOUR";
  intervalUnit["DAY"] = "DAY";
  intervalUnit["WEEK"] = "WEEK";
  intervalUnit["MONTH"] = "MONTH";
  intervalUnit["QUARTER"] = "QUARTER";
  intervalUnit["YEAR"] = "YEAR";
})(intervalUnit || (intervalUnit = {}));
export let optState;
(function (optState) {
  optState["DOUBLE_OPT_IN"] = "DOUBLE_OPT_IN";
  optState["OPT_IN"] = "OPT_IN";
  optState["OPT_OUT"] = "OPT_OUT";
  optState["NOT_OPTED"] = "NOT_OPTED";
})(optState || (optState = {}));
export let subscriptionChangeSource;
(function (subscriptionChangeSource) {
  subscriptionChangeSource["SOURCE_LIST_UNSUBSCRIBE"] = "SOURCE_LIST_UNSUBSCRIBE";
  subscriptionChangeSource["SOURCE_IMPORT"] = "SOURCE_IMPORT";
  subscriptionChangeSource["SOURCE_SPAM_REPORT"] = "SOURCE_SPAM_REPORT";
  subscriptionChangeSource["SOURCE_NON_DELIVERY_REPORT"] = "SOURCE_NON_DELIVERY_REPORT";
  subscriptionChangeSource["SOURCE_HUBSPOT"] = "SOURCE_HUBSPOT";
  subscriptionChangeSource["SOURCE_DIRECT_COMPLAINT"] = "SOURCE_DIRECT_COMPLAINT";
  subscriptionChangeSource["SOURCE_MTA_RECORD"] = "SOURCE_MTA_RECORD";
  subscriptionChangeSource["SOURCE_SENDGRID"] = "SOURCE_SENDGRID";
  subscriptionChangeSource["SOURCE_RECIPIENT"] = "SOURCE_RECIPIENT";
  subscriptionChangeSource["SOURCE_HUBSPOT_CUSTOMER"] = "SOURCE_HUBSPOT_CUSTOMER";
  subscriptionChangeSource["SOURCE_MIGRATION"] = "SOURCE_MIGRATION";
  subscriptionChangeSource["SOURCE_HUBSPOT_CLEANUP"] = "SOURCE_HUBSPOT_CLEANUP";
  subscriptionChangeSource["SOURCE_KNOWN_SPAM_TRAP"] = "SOURCE_KNOWN_SPAM_TRAP";
  subscriptionChangeSource["SOURCE_SDFC_SYNC"] = "SOURCE_SDFC_SYNC";
  subscriptionChangeSource["SOURCE_PUBLIC_API"] = "SOURCE_PUBLIC_API";
  subscriptionChangeSource["SOURCE_RECIPIENT_VIA_API_GENERATED_TOKEN"] = "SOURCE_RECIPIENT_VIA_API_GENERATED_TOKEN";
  subscriptionChangeSource["SOURCE_TWO_FIFTY_OK_SPAM_TRAP"] = "SOURCE_TWO_FIFTY_OK_SPAM_TRAP";
  subscriptionChangeSource["SOURCE_LINKED_PORTAL"] = "SOURCE_LINKED_PORTAL";
  subscriptionChangeSource["SOURCE_CONVERSATIONS"] = "SOURCE_CONVERSATIONS";
  subscriptionChangeSource["SOURCE_BOTS"] = "SOURCE_BOTS";
  subscriptionChangeSource["SOURCE_FORM_SUBMIT"] = "SOURCE_FORM_SUBMIT";
  subscriptionChangeSource["SOURCE_FEEDBACK_FORM"] = "SOURCE_FEEDBACK_FORM";
  subscriptionChangeSource["SOURCE_WORKFLOW"] = "SOURCE_WORKFLOW";
  subscriptionChangeSource["SOURCE_KEYWORD"] = "SOURCE_KEYWORD";
  subscriptionChangeSource["SOURCE_ONE_CLICK"] = "SOURCE_ONE_CLICK";
})(subscriptionChangeSource || (subscriptionChangeSource = {}));
export let legalBasis;
(function (legalBasis) {
  legalBasis["LEGITIMATE_INTEREST_PQL"] = "Legitimate interest \u2013 prospect/lead";
  legalBasis["LEGITIMATE_INTEREST_CLIENT"] = "Legitimate interest \u2013 existing customer";
  legalBasis["PERFORMANCE_OF_CONTRACT"] = "Performance of a contract";
  legalBasis["CONSENT_WITH_NOTICE"] = "Freely given consent from contact";
  legalBasis["NON_GDPR"] = "Not applicable";
  legalBasis["LEGITIMATE_INTEREST_OTHER"] = "Legitimate interest - other";
  legalBasis["PROCESS_AND_STORE"] = "PROCESS_AND_STORE";
})(legalBasis || (legalBasis = {}));
export let sourceType;
(function (sourceType) {
  sourceType["V1_MIGRATION"] = "V1_MIGRATION";
  sourceType["API"] = "API";
  sourceType["PUBLIC_API"] = "PUBLIC_API";
  sourceType["BULK_ACTIONS"] = "BULK_ACTIONS";
  sourceType["IMPORT"] = "IMPORT";
  sourceType["WORKFLOW"] = "WORKFLOW";
  sourceType["ONE_TIME_JOB"] = "ONE_TIME_JOB";
})(sourceType || (sourceType = {}));
export let operator;
(function (operator) {
  operator["EQ"] = "EQ";
  operator["NEQ"] = "NEQ";
  operator["LT"] = "LT";
  operator["LTE"] = "LTE";
  operator["GT"] = "GT";
  operator["GTE"] = "GTE";
  operator["BETWEEN"] = "BETWEEN";
  operator["IN"] = "IN";
  operator["NOT_IN"] = "NOT_IN";
  operator["HAS_PROPERTY"] = "HAS_PROPERTY";
  operator["NOT_HAS_PROPERTY"] = "NOT_HAS_PROPERTY";
})(operator || (operator = {}));
export let doiState;
(function (doiState) {
  doiState["NULL_STATE"] = "NULL_STATE";
  doiState["HOLDING_PATTERN"] = "HOLDING_PATTERN";
  doiState["STARTED"] = "STARTED";
  doiState["CONFIRM_SENT"] = "CONFIRM_SENT";
  doiState["CLICKED"] = "CLICKED";
  doiState["WELCOME_SENT"] = "WELCOME_SENT";
  doiState["HUBSPOT_CONFIRMED"] = "HUBSPOT_CONFIRMED";
  doiState["CUSTOMER_CONFIRMED"] = "CUSTOMER_CONFIRMED";
  doiState["GRANDFATHER_CONFIRMED"] = "GRANDFATHER_CONFIRMED";
  doiState["USER_CONFIRMED"] = "USER_CONFIRMED";
  doiState["USER_FORM_SUBMISSION_CONFIRMED"] = "USER_FORM_SUBMISSION_CONFIRMED";
  doiState["CONFIRM_STALE"] = "CONFIRM_STALE";
  doiState["STATE_TRANSFER"] = "STATE_TRANSFER";
  doiState["RESET_NULL_STATE"] = "RESET_NULL_STATE";
})(doiState || (doiState = {}));
export let previous;
(function (previous) {
  previous["EMAIL"] = "EMAIL";
  previous["WHATSAPP"] = "WHATSAPP";
  previous["SMS"] = "SMS";
})(previous || (previous = {}));
export let subscriberType;
(function (subscriberType) {
  subscriberType["EMAIL"] = "EMAIL";
  subscriberType["CANONICAL_VID"] = "CANONICAL_VID";
  subscriberType["EMAIL_PSEUDONYM"] = "EMAIL_PSEUDONYM";
  subscriberType["FORGOTTEN"] = "FORGOTTEN";
  subscriberType["WHATSAPP"] = "WHATSAPP";
  subscriberType["SMS"] = "SMS";
})(subscriberType || (subscriberType = {}));
export let appId;
(function (appId) {
  appId["UNKNOWN"] = "UNKNOWN";
  appId["MIGRATION"] = "MIGRATION";
  appId["EMAIL_NOTIFICATIONS"] = "EMAIL_NOTIFICATIONS";
  appId["SIGNALS"] = "SIGNALS";
  appId["ACCOUNT_NOTIFICATIONS"] = "ACCOUNT_NOTIFICATIONS";
  appId["CRM"] = "CRM";
  appId["SEQUENCES"] = "SEQUENCES";
  appId["FACSIMILE"] = "FACSIMILE";
  appId["CALLING_WIDGET_UI"] = "CALLING_WIDGET_UI";
  appId["SUBSCRIPTIONS_ACCEPTANCE_TESTS"] = "SUBSCRIPTIONS_ACCEPTANCE_TESTS";
})(appId || (appId = {}));
export let defaultSubscription;
(function (defaultSubscription) {
  defaultSubscription["ONE_TO_ONE"] = "ONE_TO_ONE";
  defaultSubscription["MARKETING_INFORMATION"] = "MARKETING_INFORMATION";
  defaultSubscription["SERVICE_HUB_FEEDBACK"] = "SERVICE_HUB_FEEDBACK";
  defaultSubscription["WHATSAPP"] = "WHATSAPP";
  defaultSubscription["TRANSACTIONAL_SMS"] = "TRANSACTIONAL_SMS";
  defaultSubscription["MARKETING_SMS"] = "MARKETING_SMS";
})(defaultSubscription || (defaultSubscription = {}));
export let timeUnit;
(function (timeUnit) {
  timeUnit["DAY"] = "DAY";
  timeUnit["WEEK"] = "WEEK";
  timeUnit["MONTH"] = "MONTH";
  timeUnit["QUARTER"] = "QUARTER";
  timeUnit["YEAR"] = "YEAR";
})(timeUnit || (timeUnit = {}));
export let dateTimeFormat;
(function (dateTimeFormat) {
  dateTimeFormat["EPOCH_MILLISECONDS"] = "EPOCH_MILLISECONDS";
  dateTimeFormat["DATE"] = "DATE";
})(dateTimeFormat || (dateTimeFormat = {}));
export let distanceUnit;
(function (distanceUnit) {
  distanceUnit["MILES"] = "MILES";
  distanceUnit["KILOMETERS"] = "KILOMETERS";
})(distanceUnit || (distanceUnit = {}));
export let rollingOffsetUnit;
(function (rollingOffsetUnit) {
  rollingOffsetUnit["DAY"] = "DAY";
  rollingOffsetUnit["WEEK"] = "WEEK";
  rollingOffsetUnit["MONTH"] = "MONTH";
  rollingOffsetUnit["QUARTER"] = "QUARTER";
  rollingOffsetUnit["YEAR"] = "YEAR";
})(rollingOffsetUnit || (rollingOffsetUnit = {}));
export let statusType;
(function (statusType) {
  statusType["GLOBAL_BOUNCE"] = "GLOBAL_BOUNCE";
  statusType["SUBSCRIPTION_STATUS"] = "SUBSCRIPTION_STATUS";
  statusType["SUBSCRIPTION_SPAM_REPORT"] = "SUBSCRIPTION_SPAM_REPORT";
  statusType["PORTAL_SPAM_REPORT"] = "PORTAL_SPAM_REPORT";
  statusType["PORTAL_STATUS"] = "PORTAL_STATUS";
  statusType["ACCOUNT_BOUNCE"] = "ACCOUNT_BOUNCE";
  statusType["APP_BOUNCE"] = "APP_BOUNCE";
  statusType["PORTAL_BOUNCE"] = "PORTAL_BOUNCE";
  statusType["GLOBAL_BLOCK"] = "GLOBAL_BLOCK";
  statusType["PORTAL_QUARANTINE"] = "PORTAL_QUARANTINE";
})(statusType || (statusType = {}));
export let source;
(function (source) {
  source["SOURCE_LIST_UNSUBSCRIBE"] = "SOURCE_LIST_UNSUBSCRIBE";
  source["SOURCE_IMPORT"] = "SOURCE_IMPORT";
  source["SOURCE_SPAM_REPORT"] = "SOURCE_SPAM_REPORT";
  source["SOURCE_NON_DELIVERY_REPORT"] = "SOURCE_NON_DELIVERY_REPORT";
  source["SOURCE_HUBSPOT"] = "SOURCE_HUBSPOT";
  source["SOURCE_DIRECT_COMPLAINT"] = "SOURCE_DIRECT_COMPLAINT";
  source["SOURCE_MTA_RECORD"] = "SOURCE_MTA_RECORD";
  source["SOURCE_SENDGRID"] = "SOURCE_SENDGRID";
  source["SOURCE_RECIPIENT"] = "SOURCE_RECIPIENT";
  source["SOURCE_HUBSPOT_CUSTOMER"] = "SOURCE_HUBSPOT_CUSTOMER";
  source["SOURCE_MIGRATION"] = "SOURCE_MIGRATION";
  source["SOURCE_HUBSPOT_CLEANUP"] = "SOURCE_HUBSPOT_CLEANUP";
  source["SOURCE_KNOWN_SPAM_TRAP"] = "SOURCE_KNOWN_SPAM_TRAP";
  source["SOURCE_SDFC_SYNC"] = "SOURCE_SDFC_SYNC";
  source["SOURCE_PUBLIC_API"] = "SOURCE_PUBLIC_API";
  source["SOURCE_RECIPIENT_VIA_API_GENERATED_TOKEN"] = "SOURCE_RECIPIENT_VIA_API_GENERATED_TOKEN";
  source["SOURCE_TWO_FIFTY_OK_SPAM_TRAP"] = "SOURCE_TWO_FIFTY_OK_SPAM_TRAP";
  source["SOURCE_LINKED_PORTAL"] = "SOURCE_LINKED_PORTAL";
  source["SOURCE_CONVERSATIONS"] = "SOURCE_CONVERSATIONS";
  source["SOURCE_BOTS"] = "SOURCE_BOTS";
  source["SOURCE_FORM_SUBMIT"] = "SOURCE_FORM_SUBMIT";
  source["SOURCE_FEEDBACK_FORM"] = "SOURCE_FEEDBACK_FORM";
  source["SOURCE_WORKFLOW"] = "SOURCE_WORKFLOW";
})(source || (source = {}));
export let legalBasisType;
(function (legalBasisType) {
  legalBasisType["LEGITIMATE_INTEREST_PQL"] = "LEGITIMATE_INTEREST_PQL";
  legalBasisType["LEGITIMATE_INTEREST_CLIENT"] = "LEGITIMATE_INTEREST_CLIENT";
  legalBasisType["PERFORMANCE_OF_CONTRACT"] = "PERFORMANCE_OF_CONTRACT";
  legalBasisType["CONSENT_WITH_NOTICE"] = "CONSENT_WITH_NOTICE";
  legalBasisType["NON_GDPR"] = "NON_GDPR";
  legalBasisType["PROCESS_AND_STORE"] = "PROCESS_AND_STORE";
  legalBasisType["LEGITIMATE_INTEREST_OTHER"] = "LEGITIMATE_INTEREST_OTHER";
})(legalBasisType || (legalBasisType = {}));
export let queryStringOperator;
(function (queryStringOperator) {
  queryStringOperator["AND"] = "AND";
  queryStringOperator["OR"] = "OR";
})(queryStringOperator || (queryStringOperator = {}));
export let fieldVariant;
(function (fieldVariant) {
  fieldVariant["NONE"] = "NONE";
  fieldVariant["ANALYZED"] = "ANALYZED";
  fieldVariant["RAW"] = "RAW";
})(fieldVariant || (fieldVariant = {}));
export let order;
(function (order) {
  order["ASC"] = "ASC";
  order["DESC"] = "DESC";
})(order || (order = {}));
export let metricType;
(function (metricType) {
  metricType["SUM"] = "SUM";
  metricType["AVG"] = "AVG";
  metricType["MIN"] = "MIN";
  metricType["MAX"] = "MAX";
  metricType["DISTINCT_APPROX"] = "DISTINCT_APPROX";
  metricType["PERCENTILES"] = "PERCENTILES";
  metricType["COUNT"] = "COUNT";
})(metricType || (metricType = {}));
export let channel;
(function (channel) {
  channel["EMAIL"] = "EMAIL";
  channel["WHATSAPP"] = "WHATSAPP";
  channel["SMS"] = "SMS";
})(channel || (channel = {}));
export let changeType;
(function (changeType) {
  changeType["UNKNOWN"] = "UNKNOWN";
  changeType["CREATE"] = "CREATE";
  changeType["UPDATE"] = "UPDATE";
  changeType["ACTIVATE"] = "ACTIVATE";
  changeType["DEACTIVATE"] = "DEACTIVATE";
  changeType["CHANGE_POSITIONS"] = "CHANGE_POSITIONS";
})(changeType || (changeType = {}));
export let dependencyType;
(function (dependencyType) {
  dependencyType["WORKFLOW"] = "WORKFLOW";
  dependencyType["EMAIL_CONTENT"] = "EMAIL_CONTENT";
})(dependencyType || (dependencyType = {}));
export let gdprEnforcementLevel;
(function (gdprEnforcementLevel) {
  gdprEnforcementLevel["NONE"] = "NONE";
  gdprEnforcementLevel["COMPLY"] = "COMPLY";
  gdprEnforcementLevel["ENFORCE"] = "ENFORCE";
})(gdprEnforcementLevel || (gdprEnforcementLevel = {}));